import React, { useMemo, useEffect } from 'react';
import GroupTable from '../../components/GroupTable/GroupTable';
import { useSports } from 'containers/Mundial2026/context/SportsProvider';
import {
  transformStandingsToRanking,
  getStandingsColumns,
} from 'containers/Mundial2026/utils/standingsTransformer';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import styles from './Ranking.module.scss';
import { useSelector } from 'react-redux';
import { getTranslationEmptyOrNullKey } from 'utils/getTranslation';
import { useMundialScrollTracker } from 'containers/Mundial2026/hooks/useMundialScrollTracker';
import { useStandingsAcotations } from '../../hooks/useStandingsAcotations';

const MAX_TITLE = 34;

const ACOTACIONES = {
  PTS: 'eventodeportivo_siglas_texto_puntos',
  PTD: 'eventodeportivo_siglas_texto_partidosdisputados',
  G: 'eventodeportivo_siglas_texto_goles',
  E: 'eventodeportivo_siglas_texto_empatados',
  P: 'eventodeportivo_siglas_texto_perdidos',
  GF: 'eventodeportivo_siglas_texto_golesafavor',
  GC: 'eventodeportivo_siglas_texto_golesencontra',
  GD: 'eventodeportivo_siglas_texto_diferenciadegoles',
};

const Ranking = () => {
  const { standings, loadView } = useSports();

  useMundialScrollTracker({
    pageTitleSegments: ['tabla de posiciones', 'ranking'],
    contentSubsection: 'tabla de posiciones',
    moduloName: '',
    scrollSelectors: ['[data-role="wc-standings-view"]'],
  });

  useEffect(
    () => {
      loadView('ranking');
    },
    [loadView],
  );
  const translations = useSelector(state => state.translations);

  const { title, rows } = useMemo(
    () => transformStandingsToRanking(standings),
    [standings],
  );
  const { fixed, stats } = useMemo(() => getStandingsColumns(standings), [
    standings,
  ]);

  const statsWithTooltips = useMemo(
    () =>
      stats.map(col => {
        const cmsKey = ACOTACIONES[col.label];
        const raw = cmsKey
          ? getTranslationEmptyOrNullKey(cmsKey, translations)
          : '';
        const tooltip = !raw || raw === cmsKey ? col.label : raw;
        return { ...col, tooltip };
      }),
    [stats, translations],
  );

  const isLoading =
    !standings ||
    standings?.isFetched?.ranking !== true ||
    standings?.isLoading?.ranking;
  const acotationsByColumn = useStandingsAcotations(standings);

  if (isLoading)
    return <div className={styles['ranking']} style={{ minHeight: 740 }} />;

  if (rows.length === 0) {
    <div className={styles['ranking']} style={{ minHeight: 740 }} />;
  }

  return (
    <div className={styles['ranking']}>
      <h2 className={styles['ranking__title']}>
        {renderMaxLengthText(title || '', MAX_TITLE)}
      </h2>
      <div className={styles['ranking__table-section']}>
        <GroupTable
          groupName=""
          rows={rows}
          fixedColumns={fixed}
          statsColumns={statsWithTooltips}
        />
      </div>

      {/* Acotaciones */}
      <div className={styles['ranking__acotaciones']}>
        <div className={styles['ranking__acotaciones-grid']}>
          {acotationsByColumn.map((column, columnIndex) => (
            <div
              key={columnIndex}
              className={styles['ranking__acotaciones-column']}
            >
              {column.map(({ label }) => (
                <p key={label} className={styles['ranking__acotacion']}>
                  <strong className={styles['ranking__acotacion-abbr']}>
                    {label}:
                  </strong>{' '}
                  {getTranslationEmptyOrNullKey(
                    ACOTACIONES?.[label],
                    translations,
                  )}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ranking;
